import React from 'react';
import { bool, func, string, object } from 'prop-types';

import { connect } from 'react-redux';

import { useFormik } from 'formik';
import * as Yup from 'yup';

import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';

import EsmsDialog from '../../components/EsmsDialog';

import * as ApplicationMessageActions from '../../actions/applicationMessageActions';
import * as ErpAgentActions from '../../actions/erpAgentActions';
import * as UiActions from '../../actions/uiActions';

import classes from './RenameErpAgentModal.module.css';

const ValidationSchema = Yup.object().shape({
    name: Yup.string()
        .required()
});

const RenameErpAgentModal = ({
    agent,
    close,
    clearErrors,
    open,
    title,
    isLoading,
    toggleLoading,
    errors,
    ...props
}) => {
    const formik = useFormik({
        initialValues: {
            name: agent.name || ''
        },
        validationSchema: ValidationSchema,
        onSubmit:         async (values, { setSubmitting }) => {
            const {
                companyInfo,
                updateErpAgent
            } = props;

            setSubmitting(true);

            const agentData = {
                id:   agent.id,
                name: values.name
            };

            clearErrors();

            try {
                if (!isLoading) {
                    toggleLoading(true);
                    await updateErpAgent(companyInfo.companyId, agent.id, agentData);
                }

                handleClose();
            } catch (error) {
                setSubmitting(false);
            }
        }
    });

    const handleClose = () => {
        toggleLoading(false);
        clearErrors();
        close();
    };

    return (
        <EsmsDialog
            errors={errors}
            open={open}
            onClose={handleClose}
            title={title}
            onRendered={formik.handleReset}
            onConfirm={formik.handleSubmit}
            disabled={formik.isSubmitting}
            isLoading={isLoading}
            confirmText="Rename"
        >
            <div className={classes.formColumn}>
                <div className={classes.labelColumn}>
                    <div className={classes.labelHeader}>
                        <img src="/assets/images/erpAgentIconColor.svg" alt="erp agent icon" />
                        <span>Rename FSM Integration</span>
                    </div>
                    <div className={classes.labelContent}>
                        <p>Enter a new name for this Integration</p>
                    </div>
                </div>
                <div className={classes.inputColumn}>
                    <div className={classes.inputs}>
                        <FormControl className={classes.inputWrapper}>
                            <TextField
                                id="name"
                                name="name"
                                type="text"
                                value={formik.values.name}
                                label="Name"
                                onChange={formik.handleChange}
                                InputLabelProps={{
                                    classes: {
                                        error:   classes.error,
                                        focused: classes.labelFocused,
                                        root:    classes.label
                                    }
                                }}
                                InputProps={{
                                    onBlur:  formik.handleBlur,
                                    classes: {
                                        error:     classes.cssErrorUnderline,
                                        underline: classes.cssUnderline,
                                        root:      classes.input
                                    }
                                }}
                                FormHelperTextProps={{
                                    classes: {
                                        error: classes.error
                                    }
                                }}
                                error={Boolean(formik.errors.name) && Boolean(formik.touched.name)}
                                helperText={Boolean(formik.touched.name) && formik.errors.name}
                            />
                        </FormControl>
                    </div>
                </div>
            </div>
        </EsmsDialog>
    );
};

RenameErpAgentModal.propTypes = {
    agent: object.isRequired,
    close: func.isRequired,
    open:  bool.isRequired,
    title: string.isRequired
};

const mapStateToProps = state => {
    return {
        companyInfo: state.companyInfo,
        errors:      state.messages.errors,
        isLoading:   state.ui.isLoading
    };
};

const mapDispatchToProps = {
    ...ApplicationMessageActions,
    ...ErpAgentActions,
    ...UiActions
};

export default connect(mapStateToProps, mapDispatchToProps)(RenameErpAgentModal);
